import {
  GET_LIST_DANHSACHTHANHLY,
  GET_LIST_DANHSACHTHANHLY_SUCCESS,
  GET_LIST_DANHSACHTHANHLY_FAILURE,
  UPDATE_SEARCHTDATA_DANHSACHTHANHLY,
  UPDATE_DANHSACHTHANHLY,
} from "./actionTypes";

export const getListDanhSachThanhLy = (dataSearch) => ({
  type: GET_LIST_DANHSACHTHANHLY,
  dataSearch,
});
export const getListDanhSachThanhLySuccess = (data) => ({
  type: GET_LIST_DANHSACHTHANHLY_SUCCESS,
  payload: data,
});
export const getListDanhSachThanhLyFailure = (dataSearch) => ({
  type: GET_LIST_DANHSACHTHANHLY_FAILURE,
});
export const updateDataSearch = (data) => ({
  type: UPDATE_SEARCHTDATA_DANHSACHTHANHLY,
  payload: data,
});
export const updateListDanhSachThanhLy = (data) => ({
  type: UPDATE_DANHSACHTHANHLY,
  payload: data,
});
